export default "__VITE_ASSET__B9_xNrQ9__"